import React from "react";

export default function RatingPremiumCrown() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="h-[15px] w-[15px] shrink-0">
      <path d="m3 7 4 3 5-6 5 6 4-3-2 11H5L3 7Zm3 14h12" />
    </svg>
  );
}
